import { SIGN_IN_ERRORS, type SignInError } from '@repo/contracts';

export const SIGNED_OUT_STORAGE_KEY = 'cyrino:signed-out';
export const SESSION_CHANNEL_NAME = 'cyrino-session';
export const REFRESH_LOCK_NAME = 'cyrino-refresh';

export const SIGN_IN_ERROR_MESSAGES: Record<SignInError, string> = {
  [SIGN_IN_ERRORS.cancelled]: 'Sign-in was cancelled. You can try again when you are ready.',
  [SIGN_IN_ERRORS.expired]: 'That sign-in attempt expired. Please start again.',
  [SIGN_IN_ERRORS.exchangeFailed]:
    'We could not complete your sign-in. Please try again, and tell your administrator if it keeps happening.',
  [SIGN_IN_ERRORS.accountDisabled]:
    'Your account has been deactivated. Ask your administrator if you think that is a mistake.',
  [SIGN_IN_ERRORS.accountConflict]:
    'Your Microsoft account matches more than one person here. Ask an administrator.',
  [SIGN_IN_ERRORS.unavailable]: 'Sign-in is temporarily unavailable. Please try again in a moment.',
};

export const SIGNED_OUT_MESSAGE = 'You have signed out';

/** Where a signed-in person lands; the route guards pick the right home for their role. */
export const POST_SIGN_IN_PATH = '/';
